import DashboardHeader from '../DashboardHeader/DashboardHeader';
import TutorDashboardSidebar from '../TutorDashboardSidebar/TutorDashboardSidebar';

import Calendar from 'react-calendar';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import Button from '../Button/Button';

const TutorDashboardLayout = ({ children, dashboard }) => {
  const navigate = useNavigate();
  const [value, onChange] = useState(new Date());
  return (
    <div>
      <DashboardHeader tutor />
      <div style={{ display: 'flex' }}>
        <TutorDashboardSidebar />
        <div className='tutor-layout-body'> {children}</div>
        {dashboard && (
          <div className='tutor-layout-right'>
            <Calendar onChange={onChange} value={value} />

            {/* <div className='tutor-layout-right__bottom'>
              <svg
                width='36'
                height='24'
                viewBox='0 0 36 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M24 4V20H4V4H24ZM26 0H2C0.9 0 0 0.9 0 2V22C0 23.1 0.9 24 2 24H26C27.1 24 28 23.1 28 22V15L36 23V1L28 9V2C28 0.9 27.1 0 26 0Z'
                  fill='#7CD1B8'
                />
              </svg>
              <h3>No scheduled class</h3>
              <p>
                All upcoming classes will appear here. Set your lesson schedule
                and duration by first creating lessons for your students
              </p>
              <Button
                className={'orange-border'}
                text='Create Lesson'
                onClick={() => navigate('/tutor/live-classes')}
              />
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default TutorDashboardLayout;
